import { createContext } from "react";


export const CredentialComponent = createContext({isAuthenticated:{},setIsAuthenticated:()=>{}})